import { supabase } from "@/lib/supabase/client";
import { findPublicProfileForCard } from "@/features/cards/api/cardsApi";

export const THEME_VERSION = 1;

// Owner-side: stores only the theme color; layout is fixed.
export async function saveMyProfileTheme(card, publicProfile, themeColor) {
  const design_config = { themeColor, themeVersion: THEME_VERSION };
  const existing = publicProfile || (await findPublicProfileForCard(card.id));
  const query = existing
    ? supabase.from("public_profiles").update({ design_config }).eq("id", existing.id)
    : supabase.from("public_profiles").insert({ digital_card_id: card.id, slug: card.slug, template_id: "profile_01", status: "draft", design_config });
  const { data, error } = await query.select("id,slug,design_config,status,digital_card_id").single();
  if (error) throw error;
  return data;
}
